module.exports = __webpack_public_path__ + "img/ex-profile.e18c8b6e.jpg";